import type { QueryParam } from "@ceeferenderer/fe-renderer-sdk";
import { envConfig } from "../config/envConfigs";
import { environment } from "../../src/constants/environment";
import { flowConfig } from "../config/flowConfigs";
import { getBrowserName } from "../utils/browserName";
import { getDeviceType } from "../utils/deviceType";
import { queryParams } from "../config/queryParams";

const flowParams = flowConfig?.itgConfig;
const locationId: string = queryParams.locationId;
sessionStorage.setItem("ev_locationId", locationId ? locationId : "");
const hash = window.location.hash.substring(1);

let access_token = "";
hash.split("&").map((hk) => {
  const temp = hk.split("=");
  if (temp[0] === "access_token") {
    access_token = temp[1];
    const now = new Date();
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      expiry: now.getTime() + 3600 * 1000,
      value: "true",
    };
    sessionStorage.setItem("cimaSuccessful", JSON.stringify(item));
    sessionStorage.setItem("cimaValid", "true");
  }
});

const userIDTemp = access_token ? access_token : "";
const uri = window.location.toString();

const params = uri.split("&");
let state = "";
let locationParam: string[] = [];
let i;
let val;
for (i = 0; i < params.length; i++) {
  val = params[i].split("=");
  if (val[0] === "state") {
    state = decodeURIComponent(val[1]);
    locationParam = state.split("?");
  }
}

if (!state) {
  localStorage.removeItem("submitButton");
  localStorage.removeItem("stepId");
  localStorage.removeItem("displayFormReferenceKey");
  localStorage.removeItem("locRespAddress1");
  localStorage.removeItem("sessionId");
  localStorage.removeItem("internalCall");
  sessionStorage.removeItem("ev_submitButton");
  sessionStorage.removeItem("ev_existingUser");
  sessionStorage.removeItem("ev_isExistingUserClick");
  sessionStorage.removeItem("ev_accessTokenReceived");
} else {
  sessionStorage.setItem("ev_accessTokenReceived", access_token ? "true" : "false");
  sessionStorage.setItem("ev_existingUser", "true");
}

if (locationParam.length && locationParam[1]) {
  window.location.search = locationParam[1];
}

if (uri.indexOf("#") > 0) {
  const clean_uri = uri.substring(0, uri.indexOf("#"));
  window.history.replaceState({}, document.title, clean_uri);
}

export const queryParam: QueryParam = {
  ...queryParams,
  ...envConfig.queryParams,
  ...flowParams,
  browserName: getBrowserName(),
  cimaToken: userIDTemp,
  deviceType: getDeviceType(),
  environment,
  existingUser: localStorage.getItem("ev_existingUser") ? localStorage.getItem("ev_existingUser") : "false",
  // latest: environment !== "production",     //Not required as part of FE Migration changes
  feProcessId: "FE6143",
};
